document.addEventListener('DOMContentLoaded', function () {
	const targets = document.querySelectorAll('.js-fadein, .js-fadein-group');

	const observer = new IntersectionObserver(function (entries, observer) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-show');
				observer.unobserve(entry.target);
			}
		});
	}, {
		threshold: 0.15
	});

	targets.forEach(function (target) {
		observer.observe(target);
	});
});
/* バナー表示
---------------------------------------------------------------------------- */

$(document).ready(function() {
    var popup = $(".fixed-bnr");
    var closeBtn = $(".fixed-bnr .close");

    // 1. ページ読み込み時は必ず表示する
    popup.show();

    // 2. 閉じるボタンを押した時の処理（その場で見えなくするだけ）
    closeBtn.click(function() {
        popup.hide();
    });
});
